function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.014.559a2 2 0 011.972 0l4.234 2.4 4.195 2.466a2 2 0 01.986 1.709L22.44 12l-.039 4.866a2 2 0 01-.986 1.709L17.22 21.04l-4.234 2.4a2 2 0 01-1.972 0l-4.234-2.4-4.195-2.466a2 2 0 01-.986-1.709L1.56 12l.039-4.866a2 2 0 01.986-1.709L6.78 2.96l4.234-2.4z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.791 9.735a1.239 1.239 0 00-.884-.865C15.127 8.666 12 8.666 12 8.666s-3.127 0-3.907.204c-.43.113-.769.444-.884.865C7 10.498 7 12.089 7 12.089s0 1.59.209 2.353c.115.421.454.739.884.851.78.205 3.907.205 3.907.205s3.127 0 3.907-.205c.43-.112.769-.43.884-.85.209-.763.209-2.354.209-2.354s0-1.591-.209-2.354zm-5.814 3.798v-2.889l2.614 1.445-2.614 1.444z",
  fill: "#1976D2"
});

function SvgSocialYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgSocialYoutube;